export default "__VITE_ASSET__D_7_L626__"